export * from './NavigationDrawer';
export * from './NavigationDrawerHeader/NavigationDrawerHeader';
export * from './NavigationDrawerItem/NavigationDrawerItem';
export * from './NavigationDrawerLink/NavigationDrawerLink';
export * from './NavigationDrawerSection/NavigationDrawerSection';
export * from './model';
import { provideChameleonDesignSystem } from '../common/ChameleonDesignSystem';
import { chameleonNavigationDrawer } from './NavigationDrawer.definition';
import { chameleonNavigationDrawerItem } from './NavigationDrawerItem/NavigationDrawerItem.definition';
import { chameleonNavigationDrawerLink } from './NavigationDrawerLink/NavigationDrawerLink.definition';
provideChameleonDesignSystem().register(chameleonNavigationDrawer(), chameleonNavigationDrawerLink(), chameleonNavigationDrawerItem());
